import { useState } from "react";
import useContent from "@lib/use_content";
import useConfig from "@lib/use_config";
import Button from "@hudson/ui/components/FormFields/Button";
import ConfirmationDialog from "@hudson/ui/components//Dialogs/Confirmation";
import readRes from "@services/read_res";
import Session from "@utils/session";
import convertRes from "@services/convert_res";

export default function OpenConversionButton({
  onError,
  onSuccess,
  resId,
}: {
  onError: (message: string) => void;
  onSuccess: (message: string) => void;
  resId: number;
}) {
  const [showConvertConfirm, setShowConvertConfirm] = useState(false);

  const {
    loading: cfgLoading,
    data: cfgData,
    error: cfgError,
  } = useConfig(["allowOpenResConversion"]);
  const { data, loading, error } = useContent([
    "beConfirmDialogDefaultTitle",
    "beConvertOpenCancelButton",
    "beConvertOpenCancelConfirmation",
    "beConvertOpenButton",
    "beConvertOpenMessage",
    "beConvertOpenSuccessMessage",
    "beErrResNotConverted",
  ]);

  if (!cfgData?.config.allowOpenResConversion || !resId) return null;

  async function convert() {
    onError("");
    const success = await convertRes(resId);
    if (!success) {
      onError(data?.content.beErrResNotConverted || "System error");
    } else {
      const booking = await readRes({ resId });
      if (booking) Session.setVerifiedBooking(booking);
      await global.window.apolloClient.clearStore();
      onSuccess(data?.content.beConvertOpenSuccessMessage || "Success");
    }
  }

  return (
    <>
      <Button type="button" color="red" onClick={() => setShowConvertConfirm(true)}>
        {data?.content.beConvertOpenButton}
      </Button>

      <ConfirmationDialog
        cancelLabel={data?.content.beConvertOpenCancelButton}
        confirmLabel={data?.content.beConvertOpenButton}
        message={
          <>
            <p className="mb-2 mt-4">{data?.content.beConvertOpenMessage} </p>
            <p>{data?.content.beConvertOpenCancelConfirmation}</p>
          </>
        }
        onConfirm={convert}
        onHide={() => setShowConvertConfirm(false)}
        show={showConvertConfirm}
        title={data?.content.beConfirmDialogDefaultTitle}
        zIndexClass="z-50"
      />
    </>
  );
}
